import { Injectable } from '@angular/core';

declare global {
  interface Window { integra: any; }
}

@Injectable({
  providedIn: 'root'
})
export class WebSocketLoggerService {

  /**
   * Logs messages only when window.integra.webSocket.logging is set to true
   * @param component - The component name for prefixing (e.g., 'WebSocketSubscription', 'WebSocketService')
   * @param args - Arguments to log
   */
  log(component: string, ...args: any[]): void {
    if (this.isLoggingEnabled()) {
      console.log(`[${component}]`, ...args);
    }
  }

  /**
   * Logs error messages only when window.integra.webSocket.logging is set to true
   * @param component - The component name for prefixing
   * @param args - Arguments to log as error
   */
  error(component: string, ...args: any[]): void {
    console.error(`[${component}]`, ...args);
  }

  /**
   * Logs warning messages only when window.integra.webSocket.logging is set to true
   * @param component - The component name for prefixing
   * @param args - Arguments to log as warning
   */
  warn(component: string, ...args: any[]): void {
    console.warn(`[${component}]`, ...args);
  }

  /**
   * Checks if logging is currently enabled
   */
  isLoggingEnabled(): boolean {
    return window.integra?.webSocket?.logging === true;
  }
}
